// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

    apiKey: "AIzaSyB3q06pCQMrgCp7hric5CtpHMBjwoyAqaA",
  
    authDomain: "courtdatereminder.firebaseapp.com",
  
    projectId: "courtdatereminder",
  
    storageBucket: "courtdatereminder.firebasestorage.app",
  
    messagingSenderId: "280397722386",
  
    appId: "1:280397722386:web:e5485603b499722919f9cb",
  
    measurementId: "G-8WFF6HDQEN"
  
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// 👇 setup messaging
const messaging = getMessaging(app);
//const analytics = getAnalytics(app);

export  {app, messaging};